import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
@Pipe({
    name: 'puestos_depto' // nombre del pipe en las directivas
})

export class PuestosPipe implements PipeTransform{
    // Métdodo a implementar siempre
    transform(puestos:any){
        // Se inicializa un arreglo vacío
        let arregloPuestos = [];

        for(let item in puestos){
                arregloPuestos.push(item);
        }

        return arregloPuestos;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/puestos.pipe.ts